import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class LoggingInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Solo interceptamos las peticiones a /category
    if (request.url.includes('/category') && request.method === 'POST') {
      console.log('🔍 REQUEST INTERCEPTOR - URL:', request.url);
      console.log('🔍 REQUEST INTERCEPTOR - Method:', request.method);
      console.log('🔍 REQUEST INTERCEPTOR - Headers:', request.headers);
      
      // Intentar acceder al cuerpo de la petición
      const requestBody = request.body;
      console.log('🔍 REQUEST INTERCEPTOR - Body ORIGINAL:', JSON.stringify(requestBody, null, 2));
      
      // Verificar si es una petición a /category
      const isCategoryRequest = request.url.includes('/category');
      console.log('🔍 REQUEST INTERCEPTOR - ¿Es una petición a /category?', isCategoryRequest);
      
      // Solo modificar peticiones a /category
      if (isCategoryRequest && requestBody && typeof requestBody === 'object' && requestBody !== null) {
        if ('image' in requestBody) {
          // Usamos casting de tipo para evitar el error TS2339
          console.log('🔍 REQUEST INTERCEPTOR - Image field is present:', (requestBody as any).image);
          
          // Si el campo image está vacío o es null, intentar usar el valor de localStorage
          if (!(requestBody as any).image) {
            const lastUploadedImage = localStorage.getItem('lastUploadedCategoryImage');
            if (lastUploadedImage) {
              console.log('🔍 REQUEST INTERCEPTOR - Replacing empty image field with value from localStorage:', lastUploadedImage);
              const modifiedBody = { ...(requestBody as Record<string, any>), image: lastUploadedImage };
              request = request.clone({ body: modifiedBody });
            }
          }
        } else {
          console.log('🔍 REQUEST INTERCEPTOR - Image field is NOT present in the request body');
          
          // Solo añadir el campo image si no existe y tenemos un valor en localStorage
          const lastUploadedImage = localStorage.getItem('lastUploadedCategoryImage');
          
          if (lastUploadedImage) {
            console.log('🔍 REQUEST INTERCEPTOR - Adding image field from localStorage:', lastUploadedImage);
            
            // Crear una copia del cuerpo con el campo image añadido
            // Usamos casting explícito para evitar errores de TypeScript
            const modifiedBody = { ...(requestBody as Record<string, any>), image: lastUploadedImage };
            
            // Clonar la petición con el nuevo cuerpo
            request = request.clone({
              body: modifiedBody
            });
            
            console.log('🔍 REQUEST INTERCEPTOR - Body MODIFICADO:', JSON.stringify(request.body, null, 2));
          }
        }
      }
    }

    return next.handle(request).pipe(
      tap(event => {
        if (event instanceof HttpResponse && event.url && event.url.includes('/category')) {
          console.log('🔍 RESPONSE INTERCEPTOR - Status:', event.status);
          console.log('🔍 RESPONSE INTERCEPTOR - Body:', event.body);
        }
      })
    );
  }
}
